<app-question-base [question]="question" [isFirstQuestion]="isFirstQuestion">
  @if (displayAsSlider) {
    <app-slider
      [question]="question"
      [control]="control"
      [rowTitle]="'Hello world FIXME'"
      class="w-full"
    ></app-slider>
  } @else {
    <div
      role="radiogroup"
      class="mt-2 flex w-full gap-2"
      [ngClass]="{
        'flex-col items-stretch': isVerticalLayout,
        'flex-nowrap justify-center xl:justify-evenly items-center':
          !isVerticalLayout,
      }"
      #npsOptions
    >
      @for (alternative of question.alternatives; track $index) {
        <label
          [for]="alternative.id"
          class="relative text-2xl items-center justify-center font-normal flex gap-2 cursor-pointer h-[60px] transition-transform-slow lg:hover:scale-y-[1.05] lg:hover:scale-x-[1.01] md:hover:font-bold"
          [ngClass]="{
            'bg-secondary text-white': control.value === alternative.id,
            'text-black': control.value !== alternative.id,
            'w-[56px] flex-col': !isVerticalLayout,
            'w-full': isVerticalLayout,
          }"
        >
          <input
            type="radio"
            [formControl]="control"
            [id]="alternative.id"
            [name]="question.id"
            [attr.aria-checked]="
              control.value === alternative.id ? 'true' : 'false'
            "
            [attr.name]="question.id"
            (click)="toggleSelection(alternative.id)"
            (keydown)="handleKeydown($event, alternative.id)"
            [value]="alternative.id"
            class="cursor-pointer sr-only"
          />
          <span>{{ alternative.title }}</span>
        </label>
      }
    </div>

    @if (control?.hasError("required") && control.touched) {
      <app-validator
        [validator]="ValidatorType.RequiredSelect"
        [question]="question"
      ></app-validator>
    }
  }
</app-question-base>
